module.exports = __webpack_public_path__ + "static/media/p21.733245d6.jpeg";